import { ref, reactive, defineComponent, onBeforeUnmount, watch, computed } from 'vue';
import { TCheckbox, TIcon, TSelect } from '@tencent/web-vbui';
import { baseMixins } from '@common/mixins/baseMixins';
import { toast } from '@tencent/web-vbui/dist/components/t-toast/toast';
import { i18n, toRequest } from '@tencent/vb-web-base';
import { isFusionBankApp, to } from '@tencent/vb-web-base-core';
import { encryptText } from '../../../core/utils';
import { RegisterMobile } from '../../../core/network/NodeAPI';
import Contract from '@tencent/vb-web-contract';
export default defineComponent({
    components: {
        TCheckbox,
        TIcon,
        TSelect
    },
    emits: ['update:modelValue', 'close', 'cancel', 'confirm'],
    props: {
        modelValue: { type: Boolean, default: false },
    },
    setup(props, context) {
        const show = () => context.emit('update:modelValue', true);
        const hide = () => context.emit('update:modelValue', false);
        // 监听modelValue, 实现内部的显示、隐藏逻辑
        const stopWatch = watch(() => props.modelValue, (newValue) => {
            newValue ? show() : hide();
        });
        onBeforeUnmount(() => {
            hide();
            stopWatch();
        });
        const { isEng } = baseMixins();
        const { getT } = i18n;
        // i18n.setLang('en-GB');
        const $t = getT();
        // 表单数据
        const formData = reactive({
            selectArea: 0,
            mobile: '',
            code: '',
            isAgreeTerms: false,
            isAgreeMessage: false,
        });
        const areaCodeList = [
            {
                key: '1',
                value: '+852'
            },
            {
                key: '2',
                value: '+86'
            }
        ];
        const areaCode = computed(() => areaCodeList[formData.selectArea].value);
        const error = reactive({
            mobile: '',
            code: '',
        });
        const codeBtnText = ref($t('获取验证码'));
        const isCodeBtnEnable = ref(true);
        const getAuthCode = async () => {
            if (!isCodeBtnEnable.value) {
                return;
            }
            if (!formData.mobile) {
                toast.show({
                    title: $t('手机号码格式不正确'),
                    timeout: 1000,
                });
                return;
            }
            // 获取验证码请求
            const [data, error] = await toRequest({
                url: '/node/loan/teslaPreRegister/getCaptchaCode',
                method: 'post',
                data: { mobile: encryptText(formData.mobile), areaCode: areaCode.value },
            });
            if (!data || error) {
                toast.show({
                    title: $t('获取验证码失败'),
                    timeout: 2000,
                });
                return;
            }
            let second = 60;
            codeBtnText.value = `${$t('重新获取')}(${second}${$t('秒')})`;
            isCodeBtnEnable.value = false;
            const tick = setInterval(() => {
                second -= 1;
                if (second === 0) {
                    clearInterval(tick);
                    codeBtnText.value = $t('重新获取');
                    isCodeBtnEnable.value = true;
                }
                else {
                    codeBtnText.value = `${$t('重新获取')}(${second}${$t('秒')})`;
                }
            }, 1000);
        };
        // 立即登记
        const state = ref('register');
        const isBtnDisabled = computed(() => !formData.isAgreeTerms || !formData.mobile.trim() || !formData.code.trim() || error.mobile);
        const submittedContent = computed(() => {
            switch (state.value) {
                case 'suc':
                    return $t('请前往富融银行App继续入会，成功入会即可获港币100元现金奖赏及其他丰富会员礼遇。');
                case 'registered-tesla':
                    return $t('尊敬的Tesla车主，您已可享受一口价3.88%实际年利率贷款及高达港币10,000元的Tesla车主专享礼遇，无需再次登记。');
                case 'registered-notesla':
                    return $t('您已成功入会，可到Fusion Bank App 查看入会赏。');
                default:
                    return '';
            }
        });
        const register = async () => {
            if (isBtnDisabled.value) {
                return;
            }
            const params = {
                areaCode: areaCode.value,
                mobile: encryptText(formData.mobile),
                captcha: formData.code,
            };
            const [data, err] = await to(RegisterMobile(params));
            if (err) {
                toast.show({
                    title: err.message,
                    timeout: 3000,
                });
                return;
            }
            state.value = data;
        };
        const inputMobile = ({ target }) => {
            const { value } = target;
            error.mobile = '';
            if (value.length > 0 && !/^[0-9]+$/.test(value)) {
                error.mobile = $t('手机号码格式不正确');
            }
        };
        const goFusionBankApp = () => {
            if (isFusionBankApp) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                window.top.window.location.href =
                    'https://www.fusionbank.com/h5/walletLoan/app/index.html?product_no=FyvFkIqLYfHM3ju&from=home#/limit';
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                window.top.location.href = 'https://www.fusionbank.com/download.html';
            }
        };
        // 查看协议
        const checkProto = async (key) => {
            const contract = new Contract({
                key,
                autoSign: false,
                containerType: 'dialog',
                needAgree: false,
                needCheckBox: false,
                hideBtn: true,
                needTitle: false,
                needLogin: false,
            });
            hide();
            await contract.preview();
            show();
        };
        return {
            isEng,
            hide,
            areaCodeList,
            formData,
            error,
            getAuthCode,
            codeBtnText,
            register,
            isBtnDisabled,
            submittedContent,
            state,
            inputMobile,
            goFusionBankApp,
            checkProto,
        };
    },
});
